import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { MINUTES_TO_MILLIS } from "lopermut"
import { DataResponse, SupportAmphoraTicketMessagesResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof SupportAmphoraTicketMessagesResponseDataSchema>>

type Props = {
  enabled?: boolean
} & ({ ticketId: string } | { issueId: string })

export const amphoraTicketMessagesQuery = (props: Props) => {
  const entity = "issueId" in props ? "issues" : "tickets"
  const id = "issueId" in props ? props.issueId : props.ticketId

  return queryOptions({
    queryKey: ["support", entity, id, "amphora", "messages"],
    queryFn: async () => {
      const response = await axios.get<Response>(`/support/${entity}/${id}/amphora/messages`)

      return response.data.data
    },
    enabled: props.enabled,
    staleTime: 5 * MINUTES_TO_MILLIS,
  })
}
